module.exports = __webpack_public_path__ + "img/help-title.acc50e8b.png";